import { render, staticRenderFns } from "./InDesignEditorDialog.vue?vue&type=template&id=af5b0b9e&scoped=true"
import script from "./InDesignEditorDialog.vue?vue&type=script&lang=js"
export * from "./InDesignEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5b0b9e",
  null
  
)

export default component.exports